import { FDLozenge, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';

const EstatePlanningLozenge = ({
  resource,
}) => {
  const estatePlanLabel = resource?.attr('currentEstatePlanLabel');
  const estatePlanStatusColor = resource?.attr('currentEstatePlanStatusColor');

  if (!estatePlanLabel) {
    return null;
  }

  return (
    <FDStack alignItems={'center'}>
      <FDLozenge color={estatePlanStatusColor ?? 'info'} label={estatePlanLabel} size={'lg'} />
    </FDStack>
  );
};

EstatePlanningLozenge.defaultProps = {};

EstatePlanningLozenge.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { EstatePlanningLozenge };
